<template>
  <div class="page-scroll-container" ref="pageContainer" id="page4-container">
    <!-- 1. [底层] 清晰背景图 (始终可见，作为底色) -->
    <img
      class="bg-layer clear-bg"
      src="../../../assets/annualReport/page4_store_bag.png"
      alt="bg-clear"
    />

    <!-- 2. [中间层] 预渲染的模糊/变暗背景图 (控制 Opacity 实现渐变) -->
    <!-- 这一层淡入时，会盖住底层的清晰图，实现模糊效果 -->
    <img
      class="bg-layer blur-bg"
      :class="{ active: isVisible }"
      src="../../../assets/annualReport/page4_blur.png"
      alt="bg-blur"
    />

    <!-- 3. [顶层] 核心卡片 -->
    <div class="visual-card" :class="{ 'start-anim': isVisible }">
      <!-- 卡片内部背景：必须有一张清晰的图来模拟“聚光灯”下的清晰区域 -->
      <!-- 它的层级在模糊层之上，所以看起来中间是清晰的 -->
      <div class="card-bg-container">
        <img
          class="card-img"
          src="../../../assets/annualReport/page4_store_bag.png"
          alt="card-bg"
        />
      </div>
      <div class="black-board-overlay">
        <div class="content">
          <!-- 第一组 -->
          <div
            class="item-row anim-step-1"
            v-if="reportData.cityName && reportData.shopName"
          >
            <div>经全年观察，您将</div>
            <div class="limit-two-lines">
              <span class="dynamic"
                >{{ reportData.cityName }}·{{ reportData.shopName }}</span
              >
            </div>
            <div>设为主要据点</div>
          </div>
          <div class="item-row anim-step-1" v-else>
            <div>经全年观察，您完美</div>
            <div>践行<span class="preference-hot">"流动办公"</span>理念</div>
            <div>每间门店都可能</div>
            <div>被您设为主要据点</div>
          </div>

          <!-- 中间容器 -->
          <div>
            <div class="item-row2" v-if="reportData.totalBeveragesPurchased">
              <div class="anim-step-2">
                品鉴试喝<span class="dynamic num">{{
                  reportData.totalBeveragesPurchased
                }}</span
                ><span class="dynamic">次，</span>
              </div>

              <div class="anim-step-3">
                参与度达到<span class="dynamic num"
                  >{{ Math.round(reportData.participationRate * 100) }}%</span
                >
              </div>
            </div>
            <div class="item-row5" v-else>
              <div class="anim-step-2">口味信息已采集</div>
              <div class="anim-step-3">期待您的品鉴</div>
            </div>

            <div
              class="item-row3 anim-step-4"
              v-if="
                reportData.temperaturePreference &&
                reportData.temperaturePreference == 1
              "
            >
              <div>在项目投资中，您擅长</div>
              <div>
                以<span class="dynamic preference">冰点思维</span>洞察全局
              </div>
            </div>
            <div
              class="item-row3 anim-step-4"
              v-else-if="
                reportData.temperaturePreference &&
                reportData.temperaturePreference == 2
              "
            >
              <div>在项目投资中，您始终</div>
              <div>
                以<span class="dynamic preference-hot">热忱姿态</span>推进协作
              </div>
            </div>
            <div
              class="item-row3 anim-step-4"
              v-else-if="
                reportData.temperaturePreference &&
                reportData.temperaturePreference == 3
              "
            >
              <div>在项目投资中您深谙</div>
              <div>均衡之道，雨露均沾</div>
            </div>
          </div>
          <!-- 最后一组 -->
          <div class="item-row4 anim-step-5" v-if="reportData.mostIPName">
            <!-- 修改开始：添加 class "auto-wrap-line" -->
            <div class="auto-wrap-line">
              <!-- IP 名称 -->
              <span class="dynamic">{{ reportData.mostIPName }}</span>
              <!-- 后缀文案：添加 class "no-break" 确保这几个字作为一个整体移动 -->
              <span class="no-break">联名项目中</span>
            </div>
            <!-- 修改结束 -->

            <div>凸显实力，收获满载</div>
          </div>
          <div class="item-row4 anim-step-5" v-else>
            <div>流量密码掌握在手</div>
            <div>随时由您来开启</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page4Store",
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },

  mounted() {
    // 进入页面时，给 body 加上锁
    document.body.classList.add("lock-scroll");
    const vm = this;

    vm.observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        if (entry.isIntersecting) {
          console.log("Page4 进入视野");
          vm.isVisible = true;
        } else {
          console.log("Page4 离开视野");
          vm.isVisible = false;
        }
      },
      { threshold: 0.2 } // 稍微降低阈值，确保更容易触发
    );

    if (vm.$refs.pageContainer) {
      vm.observer.observe(vm.$refs.pageContainer);
    }
  },

  beforeDestroy() {
    // 离开页面时，把锁解开，防止影响其他普通页面的滚动
    document.body.classList.remove("lock-scroll");
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
/* =========================================
   1. 外层容器
   ========================================= */
.page-scroll-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 兜底背景色，防止图片加载间隙的黑屏 */
  background-color: #1a1a1a;
}

/* 
   2. 背景层控制 (绝对定位铺满屏幕)
*/
.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 防止遮挡交互 */

  /* H5 关键修改: 替代 mode="aspectFill" */
  object-fit: cover;
}

/* 底层：清晰图 */
.clear-bg {
  z-index: 0;
}

/* 中间层：模糊图 */
.blur-bg {
  z-index: 1;
  opacity: 0; /* 默认不可见 */
  transition: opacity 1.2s ease-in-out;
  will-change: opacity;
  transform: translateZ(0); /* 开启硬件加速 */

  /* 当 isVisible 为 true 时，模糊图淡入覆盖清晰图 */
  &.active {
    opacity: 1;
  }
}

/* =========================================
   3. 核心卡片 (适配逻辑修改)
   ========================================= */
.visual-card {
  position: relative;
  /* 必须高于模糊层 (z-index: 1) */
  z-index: 2;

  /* --- 默认状态：适应主流手机 (6.1 - 6.9英寸) --- */
  width: 100vw;
  height: 100vh;

  /* 移除原有的 background-image，改用内部 img 标签 */
  /* background-image: ... */

  container-type: size;
  isolation: isolate; /* 创建新的层叠上下文 */

  /* 在手机上，1单位 = 1% 屏幕宽度 */
  --unit: 1vw;
}

/* 卡片内部的背景容器 */
.card-bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  /* 关键：防止渲染闪烁或透视问题 */
  transform: translateZ(0);
  backface-visibility: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  display: block;
  /* H5 关键修改: 替代 mode="scaleToFill" */
  object-fit: fill;
}

/* --- 情况 A: 屏幕太宽 (平板/PC/折叠屏展开) --- */
@media (min-aspect-ratio: 13/25) {
  .visual-card {
    height: 100vh;
    /* 锁定为标准 iPhone 比例 390/844 ≈ 0.462 */
    width: calc(100vh * 390 / 844);
    aspect-ratio: 390 / 844;

    /* 重新计算单位 */
    --unit: 0.462vh;
  }
}

/* --- 情况 B: 屏幕太长 (极少数超长带鱼屏) --- */
@media (max-aspect-ratio: 9/21) {
  .visual-card {
    width: 100vw;
    height: calc(100vw * 844 / 390);
    aspect-ratio: 390 / 844;
    --unit: 1vw;
  }
}

/* =========================================
   4. 内容布局 (保持原有逻辑)
   ========================================= */
.black-board-overlay {
  position: absolute;
  top: 21%;
  left: 5%;
  width: 49%;
  height: 46%;
  display: flex;
  align-items: center;
}
.content {
  // position: absolute;
  // top: 26.5%;
  // left: 5%;
  width: 100%;
  height: auto; /* 由内容撑开 */

  display: flex;
  flex-direction: column;
  gap: calc(4.5 * var(--unit));

  font-size: calc(4.3 * var(--unit));
  color: #ffecb8;
  font-weight: 600;
}

.item-row {
  display: flex;
  flex-direction: column;
  gap: calc(2.1 * var(--unit));
  // line-height: 1.5;
  > div:nth-child(2) {
    line-height: 1.4; // 这里的数值越大，换行后的间隙越大
  }
}

.limit-two-lines {
  /* 核心代码：多行省略号 */
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数：这里设为 2 */

  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */

  /* 辅助代码：防止长英文或数字不换行 */
  word-break: break-all;

  /* 继承原有的行高设置，确保显示美观 */
  line-height: 1.4;
}

.item-row2 {
  display: flex;
  flex-direction: column;
}

.item-row3 {
  margin-top: calc(1.5 * var(--unit));
  display: flex;
  flex-direction: column;
  gap: calc(1.9 * var(--unit));
}

/* 新增样式 */
.auto-wrap-line {
  display: flex;
  flex-wrap: wrap; /* 核心：允许换行 */
  align-items: baseline; /* 保持文字基线对齐 */
  row-gap: calc(
    0.5 * var(--unit)
  ); /* 如果换行了，行与行之间稍微留点缝隙，不要太挤 */
}

.no-break {
  white-space: nowrap; /* 核心：禁止“联名项目中”这几个字内部换行 */
}

.item-row4 {
  margin-top: calc(1.5 * var(--unit));
  display: flex;
  flex-direction: column;
  gap: calc(1.9 * var(--unit));
}

.item-row5 {
  display: flex;
  flex-direction: column;
  gap: calc(2.1 * var(--unit));
}

.dynamic {
  color: #ffa300;
  font-size: calc(4.5 * var(--unit));
  font-family: "MontserratRoman-SemiBold", sans-serif;
  font-weight: 600;
}

.num {
  font-size: calc(7 * var(--unit));
  position: relative;
  top: calc(0.3 * var(--unit)); /* 微调：正数向下移动，负数向上移动 */
}

.preference {
  font-weight: 600;
  font-size: calc(4.1 * var(--unit));
  color: #7ae7f9;
}
.preference-hot {
  font-weight: 600;
  font-size: calc(4.1 * var(--unit));
  color: #ffa300;
}

/* =========================================
   5. 动画控制逻辑
   ========================================= */

.anim-step-1,
.anim-step-2,
.anim-step-3,
.anim-step-4,
.anim-step-5 {
  opacity: 0;
}

/* 文字依次上浮 */
.start-anim .anim-step-1 {
  animation: textFloatUp 1.2s ease-out forwards;
  animation-delay: 0.3s;
}
.start-anim .anim-step-2 {
  animation: textFloatUp 1.2s ease-out forwards;
  animation-delay: 0.8s;
}
.start-anim .anim-step-3 {
  animation: textFloatUp 1.2s ease-out forwards;
  animation-delay: 0.8s;
}
.start-anim .anim-step-4 {
  animation: textFloatUp 1s ease-out forwards;
  animation-delay: 1.3s;
}
.start-anim .anim-step-5 {
  animation: textFloatUp 1s ease-out forwards;
  animation-delay: 1.8s;
}

@keyframes textFloatUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
